import $ from 'jquery';
import 'jquery.easing';

import { LG_BREAKPOINT } from '../constants/constants';

const $window = $(window);
const $tabs = $('.tabs-filter');

$tabs.each((_, el) => {
  const $el = $(el);
  const $scroller = $el.find('.tabs-filter-bar-scroller');
  const $tabBarList = $el.find('.tabs-filter-bar-list');
  const $tabBtns = $el.find('.tabs-filter-bar-btn');
  const $prevBtn = $el.find('.tabs-filter-bar-control-prev');
  const $nextBtn = $el.find('.tabs-filter-bar-control-next');
  const $contentItems = $el.find('.tabs-filter-content-item');
  const $dropDownBtn = $el.find('.tabs-filter-bar-select-btn');
  const $dropDownBtnLabel = $dropDownBtn.find('.tabs-filter-bar-select-label');
  const $dropDown = $el.find('.tabs-filter-bar-scroller');
  let currentIndex = null;
  let windowWidth = 0;
  let isMobile = true;
  let isOpen = false;

  // Track window size
  // ------------------------------------------------------------------------ //
  function checkWindowSize() {
    windowWidth = $window.width();

    if (windowWidth >= LG_BREAKPOINT) {
      isMobile = false;
    } else {
      isMobile = true;
    }

    // Show/hide the tab bar prev/next arrows
    if ($tabBarList.outerWidth() > $scroller.outerWidth()) {
      $el.addClass('is-scrollable');
    } else {
      $el.removeClass('is-scrollable');
    }
  }
  $window.resize(() => {
    checkWindowSize();
  });

  // Do this first time page loads
  checkWindowSize();

  // Dropdown functionality
  // ------------------------------------------------------------------------ //
  function closeDropDown() {
    if (isMobile) {
      isOpen = false;
      // Animate the height of the drop down
      $dropDown.animate({ height: 0 }, 250, 'easeInOutQuad', () => {
        // Move drop down off screen
        $el.removeClass('is-open');
        // clear out the inline styles so things work responsively
        $dropDown.attr('style', '');

        $dropDownBtn.focus();
      });
    }
  }

  function openDropDown() {
    if (isMobile) {
      isOpen = true;
      // Get height of drop down
      // (which is absolutely positioned off the left of the screen)
      const height = $dropDown.outerHeight();
      // Make height 0
      $dropDown.css('height', 0);
      // Bring drop down onto the screen
      $el.addClass('is-open');
      // Animate the height of the drop down
      $dropDown.animate({ height }, 250, 'easeInOutQuad', () => {
        // clear out the inline styles so things work responsively
        $dropDown.attr('style', '');
      });
    }
  }

  function toggleDropDown() {
    if (isOpen) {
      closeDropDown();
    } else {
      openDropDown();
    }
  }

  // Tab/filter Functionality
  // ------------------------------------------------------------------------ //
  function hideItem(itemIndex) {
    if (itemIndex !== null) {
      const $item = $($contentItems[itemIndex]);

      $item.removeClass('is-current');
      $($tabBtns[itemIndex]).removeClass('is-current');
      // WCAG
      $($tabBtns[itemIndex]).attr('aria-selected', false);
      $($tabBtns[itemIndex]).attr('tabindex', -1);

      // If hiding the current item reset the currentIndex
      if (itemIndex === currentIndex) {
        currentIndex = null;
      }
    }
  }

  function showItem(itemIndex) {
    const $item = $($contentItems[itemIndex]);
    const $currentTabBtns = $($tabBtns[itemIndex]);

    $item.addClass('is-current');
    $currentTabBtns.addClass('is-current');
    // WCAG 
    $currentTabBtns.attr('aria-selected', true);
    $($tabBtns[itemIndex]).removeAttr('tabindex');

    // Update the dropdown button
    $dropDownBtnLabel.text(
      $currentTabBtns.find('.tabs-filter-bar-label').text()
    );

    closeDropDown();

    // Hide the current item
    hideItem(currentIndex);
    // Update the index
    currentIndex = itemIndex;
  }

  // Show the first item
  showItem(0);

  // Tab bar scroll functionality
  // ------------------------------------------------------------------------ //
  function scrollTabBar(direction) {
    let newScrollLeft = 0;
    if (direction === 'right') {
      newScrollLeft = $scroller.scrollLeft() + windowWidth / 2;
    } else {
      newScrollLeft = $scroller.scrollLeft() - windowWidth / 2;
    }

    $scroller.animate({ scrollLeft: newScrollLeft }, 400, 'easeInOutQuad');
  }

  function checkScrollPosition() {
    const scrollLeft = $scroller.scrollLeft();
    if (scrollLeft > 0) {
      $prevBtn.addClass('is-enabled');
    } else {
      $prevBtn.removeClass('is-enabled');
    }

    if (scrollLeft < $tabBarList.outerWidth() - windowWidth) {
      $nextBtn.addClass('is-enabled');
    } else {
      $nextBtn.removeClass('is-enabled');
    }
  }

  $scroller.on('scroll', () => {
    checkScrollPosition();
  });

  checkScrollPosition();

  $prevBtn.click(e => {
    e.preventDefault();
    scrollTabBar('left');
  });

  $nextBtn.click(e => {
    e.preventDefault();
    scrollTabBar('right');
  });

  // The tab bar buttons that also double as the drop down
  $tabBtns.each((btnIndex, btnEl) => {
    const $btn = $(btnEl);
    $btn.click(e => {
      // unset value for scroll to not disturb the page
      if (document.getElementsByClassName('page-body')[0]) {
        document.getElementsByClassName('page-body')[0].style.overflow = 'unset';
      }
      // scroll to the tabs top
      var tabScrollEl = document.getElementById($btn.parent('a').attr('data-scroll-id'));
      if (tabScrollEl) {
        tabScrollEl.scrollIntoView();      
      }
      e.preventDefault();
      if (btnIndex !== currentIndex) {
        showItem(btnIndex);
      }
    });
  });

  // Dropdown button
  $dropDownBtn.click(e => {
    e.preventDefault();
    toggleDropDown();
  });
});
